
import Web3j from "./Web3";



export class CoinContract {
    constructor(contractAbi, contractAddress) {
        this.web3j = new Web3j()
        this.contractAddress = contractAddress
        this.contract = this.web3j.getContract(contractAbi, contractAddress)
    }

    approve(amount, ContractAddress, address = ethereum.selectedAddress) {
        // console.log(`amount: ${amount}`)
        // let num = mul(amount, d18)
        console.log(`数量：${amount}`)
        let data = this.contract.methods.approve(ContractAddress, amount).encodeABI()
        return this.web3j.sendTransaction('0x0', data, address, this.contractAddress)
    }

    balanceOf(address = ethereum.selectedAddress) {
        return this.contract.methods.balanceOf(address).call()
    }

    allowance(contract, address = ethereum.selectedAddress) {
        return this.contract.methods.allowance(address, contract).call()
    }

    getTransactionReceipt(hash) {
        return this.web3j.getTransactionReceipt(hash)
    }

    buyMp(amount, transferAddress, address = ethereum.selectedAddress) {
        console.log(`转账金额${amount},转账合约${this.contractAddress}，转给${transferAddress}`)
        let data = this.contract.methods.transfer(transferAddress, amount).encodeABI()
        return this.web3j.sendTransaction('0x0', data, address, this.contractAddress)
    }

    JoinGame(address = ethereum.selectedAddress) {
        let data = this.contract.methods.JoinGame().encodeABI()
        return this.web3j.sendTransaction('0x0', data, address, this.contractAddress)
    }
    bindIntro(invite_address, address = ethereum.selectedAddress) {
        console.log(invite_address)
        let data = this.contract.methods.bindIntro(invite_address).encodeABI()
        return this.web3j.sendTransaction('0x0', data, address, this.contractAddress)
    }
    invest(payType, orderNum, amount, address = ethereum.selectedAddress) {
        console.log(payType, orderNum, amount)
        let data = this.contract.methods.invest(payType.toString(), orderNum.toString(), amount).encodeABI()
        return this.web3j.sendTransaction('0x0', data, address, this.contractAddress)
    }
}
